import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4109806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "doctorList" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "의료진 현황", -1))
const _hoisted_3 = { class: "table-search" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "글 목록", -1))
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "hidden" }, "분류", -1))
const _hoisted_7 = { class: "tr th" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<span class=\"col1 col-number\" data-v-f4109806>No.</span><span class=\"col2\" data-v-f4109806>등록일</span><span class=\"col3\" data-v-f4109806>승인일시</span><span class=\"col4\" data-v-f4109806>의료진명</span><span class=\"col5\" data-v-f4109806>국가</span><span class=\"col6\" data-v-f4109806>소속</span><span class=\"col7\" data-v-f4109806>진료과목</span>", 7)
const _hoisted_15 = { class: "col8" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "hidden" }, "내용", -1))
const _hoisted_17 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "err-server"
}
const _hoisted_22 = { class: "err-server-msg" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "col1 col-number" }
const _hoisted_25 = { class: "col2" }
const _hoisted_26 = {
  key: 0,
  class: "col3 color-sub1"
}
const _hoisted_27 = {
  key: 1,
  class: "col3 color-sub1"
}
const _hoisted_28 = { class: "col4 txt-wrap" }
const _hoisted_29 = { class: "col5 txt-wrap" }
const _hoisted_30 = { class: "col6 txt-wrap" }
const _hoisted_31 = {
  key: 2,
  class: "col7"
}
const _hoisted_32 = { class: "subject-list" }
const _hoisted_33 = {
  key: 0,
  style: {"padding":"0 6px 0 0"}
}
const _hoisted_34 = {
  key: 3,
  class: "col7"
}
const _hoisted_35 = { class: "col8" }
const _hoisted_36 = { class: "status-button-vue" }
const _hoisted_37 = { class: "page-nation-vue" }
const _hoisted_38 = {
  key: 0,
  class: "currentPopup"
}

import { onBeforeMount, onMounted, watch, ref, computed } from 'vue';
import { useStore } from 'vuex';
import BoardSearcher from '@/components/item/BoardSearcher.vue';
import DoctorInfoPopup from '@/views/doctor/popup/DoctorInfoPopup.vue';
import PageNation from '@/components/item/PageNation.vue';
import StatusButton from '@/components/button/StatusButton.vue';
import BoardState from '@/components/item/BoardState.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorList',
  setup(__props) {

const store = useStore();
const Dr = store.state.moduleDr;
/**** data -------------------- */
var exception = computed(() => Dr.exception);
var doctorList = computed(() => Dr.doctorList);
var totalCount = computed(() => Dr.totalCount);
var propsPageNumber = ref(1);
var pageNumber = ref(1);
var lastPageNumber = computed(() => store.getters['moduleDr/getLastPageNumber']);
var rowNumber = ref(8);
var periodEasy = ref('00');
var dateStart = ref('');
var dateEnd = ref('');
var searchType = ref('00');
var searchWord = ref('');
var doctorState = ref('00');
var searchTypes = ref([
  { code: '00', name: '전체' },
  { code: '01', name: '의료진명' },
  { code: '04', name: '국가' },
  { code: '05', name: '소속' },
  { code: '02', name: '진료과목' },
  { code: '03', name: '진료질환' },
]);
var stateOptions = ref([
  { code: '00', name: '전체' },
  { code: '01', name: '대기' },
  { code: '02', name: '승인' },
]);
var currentDoctor = ref({});
var currentPopup = ref(null);
var isOnListLoading = ref(true);
var popupTitle = ref('');
var popupDesc = ref('');
var paramForList = ref({});
/**** methods ----------------- */
const setPeriodOption = (item: { code: string; name: string }) => {
  periodEasy.value = item.code;
};
const setDates = (start: string, end: string) => {
  // console.log(`검색: 시작일 ${start} ~ 종료일 ${end}`);
  dateStart.value = start; // yyyy-MM-dd
  dateEnd.value = end; // yyyy-MM-dd
};
const setSearchType = (item: { code: string; name: string }) => {
  searchType.value = item.code;
};
const setSearchWord = (word: string) => {
  searchWord.value = word;
};
const setStateOption = (item: { code: string; name: string }) => {
  doctorState.value = item.code;
};
const onClick_searchButton = (word: string) => {
  searchWord.value = word;
  setDoctorList(1);
};
const onClick_pageNumber = (num: number) => {
  pageNumber.value = num;
};
const onClick_close = () => {
  currentPopup.value = null;
};
const onClick_item = async (item: object, index: number) => {
  // console.log(item);
  currentDoctor.value = await item;
  currentPopup.value = DoctorInfoPopup;
};
const setDoctorList = async (pNum: number) => {
  pageNumber.value = pNum;
  isOnListLoading.value = true;
  paramForList.value = {
    page: pageNumber.value, // *
    rows: rowNumber.value, // *
    search_period: periodEasy.value,
    search_date_begin: dateStart.value,
    search_date_end: dateEnd.value,
    search_text: searchWord.value,
    search_type: searchType.value,
    apply_state: doctorState.value, // *
  };
  await store.dispatch('moduleDr/getDoctorList', paramForList.value, { root: true });
  setTimeout(() => {
    isOnListLoading.value = false;
  }, 800);
};
/**** content -----------------
 *
 * 의료진 현황
 * /
 * /
/**** hook -------------------- */
onBeforeMount(() => {
  store.state.moduleDr.doctorList = [];
});
onMounted(() => {
  setDoctorList(1);
});
watch(
  () => pageNumber.value,
  (newValue, oldValue) => {
    setDoctorList(pageNumber.value);
  },
  { deep: true }
);
watch(
  () => currentPopup.value,
  (newValue, oldValue) => {
    if (newValue === null) {
      setDoctorList(pageNumber.value);
    }
  },
  { deep: true }
);
watch(
  () => doctorState.value,
  () => {
    setDoctorList(1);
  },
  { deep: true }
);
watch(
  () => periodEasy.value,
  () => {
    setDoctorList(1);
  },
  { deep: true }
);
watch(
  () => dateStart.value,
  () => {
    setDoctorList(1);
  },
  { deep: true }
);
watch(
  () => dateEnd.value,
  () => {
    setDoctorList(1);
  },
  { deep: true }
);
watch(
  () => pageNumber.value,
  () => {
    propsPageNumber.value = pageNumber.value;
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BoardSearcher, {
          "search-types": _unref(searchTypes),
          onSetPeriodOption: setPeriodOption,
          onSetDates: setDates,
          onSetSearchType: setSearchType,
          onSetSearchWord: setSearchWord,
          onOnClick_searchButton: onClick_searchButton
        }, null, 8, ["search-types"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_15, [
            _createVNode(BoardState, {
              "state-options": _unref(stateOptions),
              onSetStateOption: setStateOption
            }, null, 8, ["state-options"])
          ])
        ]),
        _hoisted_16,
        (_unref(isOnListLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
          : _createCommentVNode("", true),
        (!_unref(isOnListLoading) && _unref(exception).doctorList.bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("p", {
                class: _normalizeClass([{ 'err-server-bang': _unref(exception).doctorList.type === 'bang' }, { 'err-server-empty': _unref(exception).doctorList.type === 'empty' }])
              }, null, 2),
              _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(exception).doctorList.desc), 1)
            ]))
          : (!_unref(isOnListLoading) && !_unref(exception).doctorList.bool)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(doctorList), (item, index) => {
                return (_openBlock(), _createElementBlock("ul", {
                  class: "td",
                  key: item
                }, [
                  _createElementVNode("li", {
                    class: "tr",
                    onClick: _withModifiers(($event: any) => (onClick_item(item, index)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(totalCount) - _unref(rowNumber) * (_unref(pageNumber) - 1) - index), 1),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(item.createdDate), 1),
                    (item.acceptedDate !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.acceptedDate), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_27, "-")),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(item.doctorName), 1),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(item.nationality), 1),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(item.affiliation), 1),
                    (item.subjects !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                          _createElementVNode("ul", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subjects, (subItem, subIndex) => {
                              return (_openBlock(), _createElementBlock("li", { key: subItem }, [
                                _createTextVNode(_toDisplayString(subItem), 1),
                                (item.subjects.length - 1 !== subIndex)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, ","))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_34, "-")),
                    _createElementVNode("span", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(StatusButton, {
                          "status-name": item.statusName
                        }, null, 8, ["status-name"])
                      ])
                    ])
                  ], 8, _hoisted_23)
                ]))
              }), 128))
            : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_37, [
        _createVNode(PageNation, {
          "props-page-number": _unref(propsPageNumber),
          "total-count": _unref(totalCount),
          "row-number": _unref(rowNumber),
          "last-page-number": _unref(lastPageNumber),
          onOnClick_pageNumber: onClick_pageNumber
        }, null, 8, ["props-page-number", "total-count", "row-number", "last-page-number"])
      ], 512), [
        [_vShow, !_unref(isOnListLoading) && !_unref(exception).doctorList.bool]
      ])
    ]),
    _createVNode(_Transition, { name: "currentPopup" }, {
      default: _withCtx(() => [
        (_unref(currentPopup) !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPopup)), {
                "popup-title": _unref(popupTitle),
                "popup-desc": _unref(popupDesc),
                "current-doctor": _unref(currentDoctor),
                onOnClick_close: _cache[0] || (_cache[0] = ($event: any) => (onClick_close()))
              }, null, 40, ["popup-title", "popup-desc", "current-doctor"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})